import MenuItem from '@mui/material/MenuItem'
import { FC, useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { usersAPI } from '../../api/usersAPI'
import FormSelect from '../FormFields/Select/FormSelect'

interface Item {
  value: string | number
  label: string
}
const AccountManagerSelect: FC = ({ disabled = false }: any) => {
  const [users, setUsers] = useState<Array<any>>([])
  const currentClientId = useSelector((state: any) => state.clients.client.id)
  const { data } = useQuery({
    queryKey: ['getUsersByClientId'],
    queryFn: async () => usersAPI.getUsersByClientId(currentClientId),
  })

  useEffect(() => {
    if (data) {
      let options: Item[] = []
      data.data.value.map((client: any) => {
        options.push({
          value: client.id,
          label: `${client.firstName}  ${client.lastName} - ${client.email}`,
        })
      })
      setUsers(options)
    }
  }, [data])

  return (
    <FormSelect
      name="accountManager"
      placeholder="Account manager"
      label="Account manager"
      disabled={disabled}
    >
      {users.map((user) => {
        return (
          <MenuItem key={user.value} value={user.value}>
            {user.label}
          </MenuItem>
        )
      })}
    </FormSelect>
  )
}

export default AccountManagerSelect
